import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  ICreateUserRequest,
  ICreateUserResponse,
  IDeleteByIdRequest,
  IDeleteUserResponse,
  IGetAllUsersResponse,
  IGetByIdRequest,
  IGetUserByIdResponse,
  IPaginationRequest,
  IUpdateUserRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { UserActions } from "redux/actions";
import { UserApiService } from "services";

function* getAllUsers(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IGetAllUsersResponse = yield call(
      UserApiService.getAllUsers,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.getAllUsers.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.getAllUsers.failed(error));
    }
  } catch (error) {
    yield put(UserActions.getAllUsers.failed(error));
  }
}

function* getUserById(action: PayloadAction<IGetByIdRequest>) {
  try {
    const result: IGetUserByIdResponse = yield call(
      UserApiService.getUserById,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.getUserById.success(result.data!));
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.getUserById.failed(error));
    }
  } catch (error) {
    yield put(UserActions.getUserById.failed(error));
  }
}

function* createUser(action: PayloadAction<ICreateUserRequest>) {
  try {
    const result: ICreateUserResponse = yield call(
      UserApiService.createUser,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.createUser.success(result.data!));
      AlertHelper.showAlert("Create Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.createUser.failed(error));
    }
  } catch (error) {
    yield put(UserActions.createUser.failed(error));
  }
}

function* updateUser(action: PayloadAction<IUpdateUserRequest>) {
  try {
    const result: ICreateUserResponse = yield call(
      UserApiService.updateUser,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.updateUser.success(result.data!));
      AlertHelper.showAlert("Update Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.updateUser.failed(error));
    }
  } catch (error) {
    yield put(UserActions.updateUser.failed(error));
  }
}
function* changePasswordUser(action: PayloadAction<IUpdateUserRequest>) {
  try {
    const result: ICreateUserResponse = yield call(
      UserApiService.updateUser,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.changePasswordUser.success(result.data!));
      AlertHelper.showAlert("Update Password Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.changePasswordUser.failed(error));
    }
  } catch (error) {
    yield put(UserActions.changePasswordUser.failed(error));
  }
}
function* deleteUser(action: PayloadAction<IDeleteByIdRequest>) {
  try {
    const result: IDeleteUserResponse = yield call(
      UserApiService.deleteUser,
      action.payload
    );
    if (result.succeeded) {
      yield put(UserActions.deleteUser.success(result.data!));
      AlertHelper.showAlert("Delete Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(UserActions.deleteUser.failed(error));
    }
  } catch (error) {
    yield put(UserActions.deleteUser.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(UserActions.getAllUsers.request, getAllUsers);
  yield takeEvery(UserActions.getUserById.request, getUserById);
  yield takeEvery(UserActions.createUser.request, createUser);
  yield takeEvery(UserActions.updateUser.request, updateUser);
  yield takeEvery(UserActions.changePasswordUser.request, changePasswordUser);
  yield takeEvery(UserActions.deleteUser.request, deleteUser);
}
